import { useBookingFeeLazyQuery } from "../../../../../services/api/types/graphql";
import { IServiceTreatment } from "../../../../../services/api/therapists";
import { useDispatch } from "react-redux";
import { actionCreators, setSummaryAmount } from "../../../../../store/checkout/actions";
import { useCallback } from "react";

type UseBookingFee = () => {
  requestBookingFee: (  
    bookingTime: Date,
    therapistUrn: string,
    treatments: IServiceTreatment[],
  ) => Promise<void>;
};

export const useBookingFee: UseBookingFee = () => {
  const dispatch = useDispatch();

  const [getBookingFee] = useBookingFeeLazyQuery();

  const requestBookingFee = useCallback(async (
    bookingTime: Date,
    therapistUrn: string,
    treatments: IServiceTreatment[],    
  ): Promise<void> => {
    dispatch(actionCreators.attemptBookingFee());
    await getBookingFee({
      variables: {
        timeStarts: bookingTime.toISOString(),
        therapistUrn,
        bookingTreatments: treatments.map(({urn, count}) => ({
          urn,
          quantity: count,
        })),
      },
      onCompleted: async (data) => {
        switch (data.bookingFee.__typename) {
          case "BookingFee":
            dispatch(actionCreators.setBookingFee(data.bookingFee.amount));
            dispatch(setSummaryAmount());
            break;
        }
      },
      errorPolicy: "all",      
    });
  }, [getBookingFee]);

  return {
    requestBookingFee,
  };
};
